export default __webpack_public_path__ + "static/media/OTEIcon.94734c62.svg";